module.exports = __webpack_public_path__ + "img/winged_serpent_small.38cd8c38.png";